import { MatDialogRef } from '@angular/material/dialog';
import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Optional, Output } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { lab } from 'd3';

@Component({
  selector: 'app-setting-filter-modal',
  templateUrl: './setting-filter-modal.component.html',
  styleUrls: ['./setting-filter-modal.component.scss']
})
export class SettingFilterModalComponent implements OnInit {
  @Input() public legend = "default";
  @Input() public label = "default";

  constructor(
    @Optional() public dialogRef: MatDialogRef<SettingFilterModalComponent>,
    private modalService: NgbModal,
    public activeModal: NgbActiveModal // private changeDetector: ChangeDetectorRef
  ) {}
  ngOnInit() {}
  closeModal() {
    this.modalService.dismissAll();
  }
  resetSettings = () => {
    this.activeModal.close({ legend: "default", label: "default" });
  };

  onYesClick = () => {
    this.activeModal.close({ legend: this.legend, label: this.label });
  };
}
